import * as React from 'react';
import type { SVGProps } from 'react';
const SvgGoldDetailsLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width={56}
    height={56}
    fill='none'
    {...props}
  >
    <circle cx={28} cy={28} r={20} fill='url(#goldDetailsLogo_svg__a)' />
    <defs>
      <pattern
        id='goldDetailsLogo_svg__a'
        width={1}
        height={1}
        patternContentUnits='objectBoundingBox'
      >
        <use xlinkHref='#goldDetailsLogo_svg__b' transform='translate(-.264)scale(.00186)' />
      </pattern>
      <image
        xlinkHref='/images/icons/gold-details-logo-e0793687.webp'
        id='goldDetailsLogo_svg__b'
        width={820}
        height={537}
        preserveAspectRatio='none'
      />
    </defs>
  </svg>
);
export default SvgGoldDetailsLogo;
